const STANDARD_DROPDOWN = 'standard';
const CATEGORISED_DROPDOWN = 'categorised';
const CATEGORISED_TYPEAHEAD = 'categorised-typeahead';

const typeaheadTemplates = [
  CATEGORISED_TYPEAHEAD,
];

const isDropDownATypeahead = (optionTemplate) => typeaheadTemplates.includes(optionTemplate);

// Some drop downs have a different data structure. This normalises that data structure for comparison to standard
// dropdowns
const normaliseDisplayOptions = (params) => {
  const {
    optionTemplate = STANDARD_DROPDOWN, // we default to standard
    displayOptions,
  } = params;


  if (optionTemplate === STANDARD_DROPDOWN) {
    return displayOptions;
  }

  if (optionTemplate === CATEGORISED_DROPDOWN) {
    const newDisplayOptions = [];

    displayOptions.forEach((category) => {
      const {
        values,
      } = category;

      values.forEach((displayOption) => {
        newDisplayOptions.push(displayOption);
      });
    });
    return newDisplayOptions;
  }

  // As we are receive a value from the server for the field, that value cannot be different from the text
  // as such we currently work on the assumption that CATEGORISED_TYPEAHEADs should always have a text value
  // identical to their value value.
  if (optionTemplate === CATEGORISED_TYPEAHEAD) {
    const newDisplayOptions = [];

    displayOptions.forEach((category) => {
      const {
        values,
      } = category;

      values.forEach((value) => {
        newDisplayOptions.push({
          value,
          text: value,
        });
      });
    });
    return newDisplayOptions;
  }

  // this is not to detect undefined, as we default to standard. This is to detect typos ect
  console.warn(`UNABLE TO NORMALISE DISPLAY OPTIONS FOR ${optionTemplate}`);

  return displayOptions;
};



// Function to return the correct display value dependent on the dropdown option template
const getSelectedOptionForDropdown = (params) => {
  const {
    optionTemplate,
    displayOptions,
    value,
  } = params;

  // There is no seperation of value and text for typeaheads. This is because the server can only
  // provide us with value which we won't necessary have the displayOptions mapping for
  if (optionTemplate === CATEGORISED_TYPEAHEAD) {
    return ({
      value,
      text: value,
    });
  }

  const normalisedDisplayOptions = normaliseDisplayOptions({
    optionTemplate,
    displayOptions,
  });

  // FN: 06/03/2020
  // By on large we have access to every fields display options. However there are edge cases
  // where we get a value back from the server that we don't have access to the front end. For
  // example there are over 1000 companies which we get the values for from the server. In these
  // edge cases we have to dynamically make the displayOptions based on this value
  const unreferencedValue = (value !== undefined) && (normalisedDisplayOptions.length === 0);

  if (unreferencedValue) {
    return ({
      text: value,
      value,
    });
  }

  return normalisedDisplayOptions.find((item) => item.value === value);
};



export {
  STANDARD_DROPDOWN,
  CATEGORISED_DROPDOWN,
  CATEGORISED_TYPEAHEAD,
  getSelectedOptionForDropdown,
  normaliseDisplayOptions,
  isDropDownATypeahead,
};

